export enum CallTypes {
  INBOUND = 'Inbound',
  OUTBOUND = 'Outbound',
  TRANSFER = 'Transfer',
  ADD_PARTICIPANT = 'AddParticipant',
  SUPERVISOR = 'Supervisor',
}

export enum CallStatuses {
  CONNECTING = 'connecting',
  RINGING = 'ringing',
  ACCEPTING = 'accepting',
  CONNECTED = 'connected',
  HANGING = 'hanging',
  ENDED = 'ended',
  DIALING = 'dialing',
  TRANSFER = 'Transfer',
  ADD_PARTICIPANT = 'AddParticipant',
}

export class Call<T = unknown> {
  constructor(
    public id: string,
    public status: CallStatuses,
    public type: CallTypes,
    public from: string,
    public to: string,
    public crmMetadata?: T,
    public isMuted: boolean = false,
    public isOnHold?: boolean,
    public name?: string,
  ) {}
}
